/**
 * Helper functions for User Management page.
 *
 * Extracted from UserManagementPage.tsx (Sub-PR 6.3).
 */

import type { UserRole } from '../../types'

const BYTES_PER_KIB = 1024

export function formatDataVolume(bytes: number): string {
  if (bytes === 0) return '0 B'
  const units = ['B', 'KB', 'MB', 'GB', 'TB']
  const i = Math.floor(Math.log(bytes) / Math.log(BYTES_PER_KIB))
  const value = bytes / Math.pow(BYTES_PER_KIB, i)
  return `${value.toFixed(value >= 100 ? 0 : 1)} ${units[i] ?? ''}`
}

export function getRoleBadgeColor(role: UserRole): string {
  switch (role) {
    case 'evidenx_admin':
      return 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200'
    case 'org_admin':
      return 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200'
    case 'investigator':
      return 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200'
    case 'analyst':
      return 'bg-stone-100 text-stone-800 dark:bg-stone-700 dark:text-stone-200'
    default:
      return 'bg-stone-100 text-stone-800 dark:bg-stone-700 dark:text-stone-200'
  }
}

export function getStatusBadgeColor(status: string): string {
  switch (status) {
    case 'active':
      return 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200'
    case 'suspended':
      return 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200'
    case 'pending':
      return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200'
    default:
      return 'bg-stone-100 text-stone-800 dark:bg-stone-700 dark:text-stone-200'
  }
}
